import { render, staticRenderFns } from "./purchaseRemits.vue?vue&type=template&id=2e1cbf2b&scoped=true&"
import script from "./purchaseRemits.vue?vue&type=script&lang=js&"
export * from "./purchaseRemits.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRemits.vue?vue&type=style&index=0&id=2e1cbf2b&prod&lang=css&"
import style1 from "./purchaseRemits.vue?vue&type=style&index=1&id=2e1cbf2b&prod&scoped=true&lang=css&"
import style2 from "./purchaseRemits.vue?vue&type=style&index=2&id=2e1cbf2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1cbf2b",
  null
  
)

export default component.exports